export enum TaskStatus {
    SUCCESS = "success",
    PENDING = "pending",
    QUEUED = "queued",
    IN_PROGRESS = "in_progress",
    SUSPENDED = "suspended",
    FAILED = "failed",
}

export enum TaskType {
    EXTRACT_EVENTS = "EXTRACT_EVENTS",
    EXTRACT_INCIDENTS = "EXTRACT_INCIDENTS",
    EXTRACT_REFERENCE_DATA = "EXTRACT_REFERENCE_DATA",
    GENERATE_REPORTS = "GENERATE_REPORTS",
    GENERATE_FILE = "GENERATE_FILE",
}
